import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/bookingChange';

import { accept } from './utils';

export default function* listenAccept() {
  yield takeEvery(actions.accept.toString(), accept);
}
